import { render, staticRenderFns } from "./informacionCompleta.vue?vue&type=template&id=9984833c&scoped=true"
import script from "./informacionCompleta.vue?vue&type=script&lang=js"
export * from "./informacionCompleta.vue?vue&type=script&lang=js"
import style0 from "./informacionCompleta.vue?vue&type=style&index=0&id=9984833c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9984833c",
  null
  
)

export default component.exports